<template>
  <div>
    <b-row>
      <b-colxx xxs="12">
        <b-card class="mb-4 weight600" title="옵션/가격">
          <template v-if="goodsType !== 'MobileCoupon' && goodsType !== 'MoneyCoupon'">
            <b-form-group label-cols="2" horizontal label="적용 요일" class="mt-4">
              <b-row align-v="center" class="justify-content-start" no-gutters>
                <b-col md="auto">
                  <b-form-radio-group v-model="_dayOfWeekType" :options="dayOfWeekTypeOption">
                  </b-form-radio-group>
                </b-col>
              </b-row>
              <b-row align-v="center" class="justify-content-start mt-1" no-gutters
                     :hidden="_dayOfWeekType !== 'Custom'">
                <b-col md="aut" class="mr-2">
                  <b-form-checkbox v-model="_monday" :checked="true" :unchecked-value="false">월</b-form-checkbox>
                </b-col>
                <b-col md="auto" class="mr-2">
                  <b-form-checkbox v-model="_tuesday" :checked="true" :unchecked-value="false">화</b-form-checkbox>
                </b-col>
                <b-col md="auto" class="mr-2">
                  <b-form-checkbox v-model="_wednesday" :checked="true" :unchecked-value="false">수</b-form-checkbox>
                </b-col>
                <b-col md="auto" class="mr-2">
                  <b-form-checkbox v-model="_thursday" :checked="true" :unchecked-value="false">목</b-form-checkbox>
                </b-col>
                <b-col md="auto" class="mr-2">
                  <b-form-checkbox v-model="_friday" :checked="true" :unchecked-value="false">금</b-form-checkbox>
                </b-col>
                <b-col md="auto" class="mr-2">
                  <b-form-checkbox v-model="_saturday" :checked="true" :unchecked-value="false">토</b-form-checkbox>
                </b-col>
                <b-col md="auto" class="mr-2">
                  <b-form-checkbox v-model="_sunday" :checked="true" :unchecked-value="false">일</b-form-checkbox>
                </b-col>
              </b-row>
            </b-form-group>

            <b-form-group label-cols="2" horizontal label="적용 가능 시간" class="mt-4">
              <div>
                <hour-minute v-for="(hourMinute, index) in _hours" :key="hourMinute.id" :data="hourMinute"
                             @delete-hour="deleteHour"></hour-minute>

                <b-row align-v="center" class="justify-content-start" no-gutters>
                  <b-button variant="outline-success" class="mt-2" size="sm" @click.prevent="addHour">시간 추가</b-button>
                </b-row>
              </div>
            </b-form-group>
            
            <b-form-group label-cols="2" horizontal label="예약불가일" class="mt-4">
              <div>
                <template>
                  <b-input-group>
                    <v-date-picker mode="single" v-model="unusableDate" :input-props="{ class:'form-control', placeholder: ''  }"></v-date-picker>
                    <template v-slot:prepend>
                      <b-input-group-text>
                        <b-icon icon="calendar"></b-icon>
                      </b-input-group-text>
                    </template>
                    <b-input-group-append>
                      <b-button variant="outline-success" @click="addUnusableDay()">날짜 추가</b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <div class="input-group" style="display: inline-flex; flex-wrap: wrap">
                    <MarkLbl v-for="(hitem, hidx) in _unusableDays" :key="hidx" :label="getUnusableDayFormat(hitem)" :index="hidx" :close="rmvUnusableDays"/>
                  </div>
                </template>
              </div>
            </b-form-group>
          </template>

          <div class="top-right-button-container mb-2">
            <b-button variant="outline-success" size="sm" @click.prevent="addOption()" class="top-right-button">추가
            </b-button>
          </div>
          <b-table
            id="table-transition-example"
            :items="_options"
            :fields="goodsType != 'MobileCoupon' && goodsType !='MoneyCoupon' ?
            this.isModifyMode ? editFields : fields: this.isModifyMode ? editCouponFields : couponFields"
            striped
            class="verticalTop"
            small
            primary-key="id"
            :tbody-transition-props="transProps"
            show-empty
          >
            <template v-slot:cell(mainOption)="row">
              <b-form-radio value="true" name="representativeId" @change="changeMainOption(row.item)"
                            v-model="row.item.mainOption" :disabled="isModifyMode"/>
            </template>

            <template v-slot:cell(optionName)="row">
              <b-input-group size="sm">
                <b-input type="text" v-model="row.item.optionName"
                         :disabled="isModifyMode&&!row.item.newOption"></b-input>
              </b-input-group>
            </template>

            <template v-slot:cell(listPrice)="row">
              <b-input-group size="sm">
                <!-- {{ row.item.listPrice }} -->
                <b-input type="" v-model="row.item.listPrice"
                         :disabled="isModifyMode&&!row.item.newOption"
                         @input="e=>row.item.listPrice=changeNum(e)"
                         ></b-input>
              </b-input-group>
            </template>

            <template v-slot:cell(salePrice)="row">
              <b-input-group size="sm">
                <b-input type="" v-model="row.item.salePrice"
                          @input="e=>row.item.salePrice=changeNum(e)"
                         :disabled="isModifyMode&&!row.item.newOption"></b-input>
              </b-input-group>
              <span style="color: red"> {{Number(row.item.listPrice.replace(",", "")) != 0 ?  100 - Math.round(Number(row.item.salePrice.replace(",", "")) / Number(row.item.listPrice.replace(",", "")) * 100)+'%' : ''}}</span>
            </template>

            <template v-slot:cell(inventory)="row">
              <b-input-group size="sm">
                <b-input type="number" v-model="row.item.inventory"
                         :disabled="isModifyMode&&!row.item.newOption"></b-input>
              </b-input-group>
            </template>

            <template v-slot:cell(headcount)="row">
              <b-input-group size="sm">
                <b-input type="number" v-model="row.item.headcount"
                         :disabled="isModifyMode&&!row.item.newOption"></b-input>
              </b-input-group>
            </template>

            <template v-slot:cell(ageGroup)="row" v-if="goodsType != 'MobileCoupon'">
              <b-form-radio-group
                :options="options_ageGroupOption"
                v-model="row.item.ageGroup"
                :disabled="isModifyMode&&!row.item.newOption"/>
            </template>

            <template v-slot:cell(status)="row">
              <b-input-group size="sm">
                {{row.item.onSale ? '판매중' : '일시중지'}}
              </b-input-group>
            </template>


            <template v-slot:cell(buttons)="row">
              <b-row align-v="center" no-gutters>
                <b-button-group vertical p-0>
                  <b-button variant="empty" class="header-icon btn-sm p-0"
                            @click="moveUpItem(row.item, row.index, $event.target)" :disabled="row.index <= 0">
                    <b-icon icon="chevron-up" font-scale="1.5"></b-icon>
                  </b-button>
                  <b-button variant="empty" class="header-icon btn-sm p-0"
                            @click="moveDownItem(row.item, row.index, $event.target)"
                            :disabled="row.index >= (_options.length - 1)">
                    <b-icon icon="chevron-down" font-scale="1.5"></b-icon>
                  </b-button>
                </b-button-group>
              </b-row>
            </template>


            <template v-slot:cell(delete)="row">
              <b-row align-v="center" no-gutters>
                <div class="p-0 ml-2">
                  <b-button variant="empty" class="header-icon btn-sm p-0"
                            @click="deleteOption(row.item, row.index, $event.target)" :disabled="isModifyMode">
                    <b-icon icon="trash" font-scale="1.5"></b-icon>
                  </b-button>
                </div>
              </b-row>
            </template>


            <template v-slot:empty>
              <h3 style="text-align:center">옵션을 등록해주세요.</h3>
            </template>
          </b-table>


        </b-card>
      </b-colxx>
    </b-row>
  </div>
</template>


<script>
  import 'vue-select/dist/vue-select.css'
  import HourMinute from "../../../../components/Business/HourMinute";
  import MarkLbl from "../../components/MarkLbl";
  import {
    mapGetters,
    mapActions,
    mapMutations,
  } from "vuex";

  export default {
    components: {
      'hour-minute': HourMinute,
      MarkLbl,
    },

    data() {
      return {
        listPriceVal: "",
        isModifyMode: false,
        isReqModifyMode: false,
        goodsParamsId: null, //등록된 상품아이디
        registerId: null, //등록대기 상품아이디
        copyRegisterId: null,
        transProps: {
          // Transition name
          name: 'list'
        },
        hourMinuteId: 0,
        hoursArr: [],
        fields: [ //신규등록신청 예약/예약권 옵션필드
          {key: 'mainOption', label: "대표옵션"},
          {key: 'optionName', label: "옵션명"},
          {key: 'listPrice', label: "정상가"},
          {key: 'salePrice', label: "판매가"},
          {key: 'inventory', label: "재고수량"},
          {key: 'ageGroup', label: "권종"},
          {key: 'headcount', label: "기준인원"},
          {key: 'delete', label: "삭제"},
          {key: 'buttons', label: "순서"},
        ],
        editFields: [  //상품수정 예약/예약권 옵션필드
          {key: 'mainOption', label: "대표옵션",class:'noWidth'},
          // {key: 'optionCode', label: "옵션코드"},
          {key: 'optionName', label: "옵션명"},
          {key: 'listPrice', label: "정상가"},
          {key: 'salePrice', label: "판매가"},

          {key: 'inventory', label: "재고수량"},
          {key: 'ageGroup', label: "권종",class:"width18"},
          {key: 'headcount', label: "기준인원"},
          {key: 'status', label: "상태",class:'noWidth'},
          {key: 'buttons', label: "순서",class:'noWidth'},
          // {key: 'delete', label: "삭제"},
        ],
        couponFields: [  //신규등록신청 모바일쿠폰/금액권 옵션필드
          {key: 'mainOption', label: "대표옵션"},
          {key: 'optionName', label: "옵션명"},
          {key: 'listPrice', label: "정상가"},
          {key: 'salePrice', label: "판매가"},
          {key: 'inventory', label: "재고수량"},
          {key: 'delete', label: "삭제"},
          {key: 'buttons', label: "순서"},
        ],
        editCouponFields: [ //상품수정 모바일쿠폰/금액권 옵션필드
          {key: 'mainOption', label: "대표옵션"},
          // {key: 'optionCode', label: "옵션코드"},
          {key: 'optionName', label: "옵션명"},
          {key: 'listPrice', label: "정상가"},
          {key: 'salePrice', label: "판매가"},
          {key: 'inventory', label: "재고수량"},
          {key: 'status', label: "상태"},
          {key: 'buttons', label: "순서"},
          // {key: 'delete', label: "삭제"},
        ],
        unusableDate: new Date(),
      }
    },
    watch: {
      _options(val) {
       
        val.forEach(el => {
          el.listPrice = el.listPrice.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,');
          el.salePrice = el.salePrice.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,');
        });
        //  console.log(val);
      },
    },
    computed: {
      ...mapGetters(['goodsType', 'options', 'mainOptionId', 'hours', 'unusableDays', 'options_ageGroupOption', 'dayOfWeekTypeOption', 'dayOfWeekType',
        'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']),

      // listPricecomputed() {
      //   this._options.forEach(el => {
      //       console.log(el.listPrice.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,'))
      //       return this.listPriceVal = el.listPrice.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,');
      //     });
      //   return this.listPriceVal
      // },
      _mainOptionId: {
        get: function() {
          return this.mainOptionId
        }, set: function(e) {
          this.setMainOptionId(e)
        }
      },


      _options: {
        get: function() {
          return this.options
        }, set: function(e) {
          this.setOptions(e)
        }
      },
      _dayOfWeekType: {
        get: function() {
          return this.dayOfWeekType
        }, set: function(e) {
          // console.log(e)
          this.setDayOfWeekType(e)
        }
      },
      _monday: {
        get: function() {
          return this.monday
        }, set: function(e) {
          this.setMonday(e)
        }
      },
      _tuesday: {
        get: function() {
          return this.tuesday
        }, set: function(e) {
          this.setTuesday(e)
        }
      },
      _wednesday: {
        get: function() {
          return this.wednesday
        }, set: function(e) {
          this.setWednesday(e)
        }
      },
      _thursday: {
        get: function() {
          return this.thursday
        }, set: function(e) {
          this.setThursday(e)
        }
      },
      _friday: {
        get: function() {
          return this.friday
        }, set: function(e) {
          this.setFriday(e)
        }
      },
      _saturday: {
        get: function() {
          return this.saturday
        }, set: function(e) {
          this.setSaturday(e)
        }
      },
      _sunday: {
        get: function() {
          return this.sunday
        }, set: function(e) {
          this.setSunday(e)
        }
      },
      _hours: {
        get: function() {
          return this.hours
        },
        set: function(e) {
          return this.setHours(e)
        }
      },
      _unusableDays: {
        get: function() {
          return this.unusableDays
        },
        set: function(e) {
          return this.setUnusableDays(e)
        }
      }
    },
    mounted() {
      //신규상품
      this.registerId = this.$route.params.registerId !== undefined ? this.$route.params.registerId : null
      if(this.registerId !== null) {
        this.isReqModifyMode = true
      }

      //등록상품
      this.goodsParamsId = this.$route.params.goodsId !== undefined ? this.$route.params.goodsId : null
      if(this.goodsParamsId !== null) {
        this.isModifyMode = true
      }

      if(this.registerId == null && this.goodsParamsId == null) {
        if(this._hours.length === 0) {
          this.addHour()
        }
        if(this._options.length === 0) {
          this.addOption()
        }

      }
      
        // console.log(this._options)

    },

    methods: {
      ...mapMutations(['setMainOptionId', 'setOptions', 'setDayOfWeekTypeOption', 'setDayOfWeekType', 'setHours', 'setUnusableDays',
        'setMonday', 'setTuesday', 'setWednesday', 'setThursday', 'setFriday', 'setSaturday', 'setSunday']),


      changeNum : function(value) {
          return value = this.comma(this.uncomma(value));
        },
       comma(str) {
           str = String(str);
           return str.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,');
       },
      uncomma(str) {
         str = String(str);
         return str.replace(/[^\d]+/g, '');
     },

      moveUpItem(item, index, button) {
        if(index <= 0) {
          return
        }
        let preItem = this._options[index - 1];
        let clickedItem = this._options[index];
        this._options.splice(index - 1, 2, clickedItem, preItem)
      },

      moveDownItem(item, index, button) {
        if(index >= (this._options.length - 1)) {
          return
        }
        let postItem = this._options[index + 1];
        let clickedItem = this._options[index];
        this._options.splice(index, 2, postItem, clickedItem)
      },


      addOption() { //옵션추가


        let mainOption = false
        if(this._options.length == 0) mainOption = true

        const option = {
          optionName: "",
          mainOption: this.isModifyMode ? false : mainOption,
          listPrice: '0',
          salePrice: '0',
          inventory: "99999",
          onSale: true,
          currencyCode: 'KRW',
        }

        if(this.goodsType == "Booking" || this.goodsType == "BookingCoupon") {
          Object.assign(option, {ageGroup: 'Adult', headcount: ""})
        }

        if(this.isModifyMode) {
          Object.assign(option, {newOption: true})
        }

        this._options.push(option)

      },


      deleteOption(item, index, button) {

        const option = this._options

        //대표옵션 삭제시 최상단옵션을 메인옵션으로 설정
        if(item.mainOption) {
          if(option.length > 0) {
            if(index == 0) {
              option[1].mainOption = true

            } else {
              option[0].mainOption = true
            }
          }
        }
        this._options.splice(index, 1)
      },

      addHour() {  //적용가능시간추가

        if(this.isModifyMode) {
          this.hourMinuteId = this._hours.length
          this._hours.push({
            id: this.hourMinuteId++,
            hour: null,
            minute: null
          })

        } else {
          this._hours.push({
            id: this.hourMinuteId++,
            hour: null,
            minute: null
          })
        }


      },

      deleteHour(id) { //적용가능시간 삭제
        // console.log(id)
        this._hours = this._hours.filter(item => item.id !== id)
      },


      changeMainOption(item) {

        this._options.forEach((v) => {
          v.mainOption = false
        })

        item.mainOption = true

      },

      addUnusableDay() {
        if (!this.unusableDate) return false;

        var newDays = this.$moment(this.unusableDate).format('YYYYMMDD');
        var tmp_array = this._unusableDays;

        tmp_array.push(newDays);
        tmp_array = tmp_array.map((hitem) => {
          return this.$moment(hitem).format('YYYYMMDD');
        });
        tmp_array.sort(function (a, b) {
            return a - b;
        });
        this._unusableDays = tmp_array.map((msitem) => {
            return (
                this.$moment(msitem).format('YYYY-MM-DD')
            );
        });
      },

      getUnusableDayFormat(val) {
        return this.$moment(val).format("YYYY-MM-DD");
      },

      rmvUnusableDays(ridx) {
        this._unusableDays.splice(ridx, 1);
      },

    },

  }
</script>

<style>
  .list-move {
    transition: transform 1s;
  }

  .list-item {
    display: inline-block;
    margin-right: 10px;
  }

  .list-enter-active, .list-leave-active {
    transition: all 1s;
  }

  .list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */
  {
    opacity: 0;
    transform: translateY(30px);
  }

  .table > tbody > tr > td {
    vertical-align: middle;
  }
</style>
